<template>
    <div class="subpackage-payment-branch-institute">
        <Pane>
            <template v-slot:extra>
                <Draft @select="onSelectDraft" />
            </template>
        </Pane>

        <div class="container">
            <a-form :form="form" :label-col="{ xs: { span: 6 }, sm: { span: 6 }, md: { span: 8 }, lg: { span: 8 } }" :wrapper-col="{ xs: { span: 18 }, sm: { span: 18 }, md: { span: 16 }, lg: { span: 16 } }" :colon="false" @submit="handleSubmit">
                <!-- 基本信息 -->
                <div class="title">基本信息</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">申请人</span>
                                <a-button block style="text-align: left">{{ user.userName }}</a-button>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">申请部门</span>
                                <a-button block style="text-align: left">{{ department.deptUniqueName }}</a-button>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>

                <!-- 项目信息 -->
                <div class="title">项目信息</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">项目名称</span>
                                <ContractSelector @change="onSelectContract">
                                    <a-button block style="text-align: left">
                                        {{ selectedContract ? selectedContract.name : '请选择合同' }}
                                    </a-button>
                                </ContractSelector>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">设计编号</span>
                                <a-input :value="selectedContract ? selectedContract.code : ''" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">购方名称</span>
                                <a-input :value="selectedContract ? selectedContract.partyAname : ''" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">合同金额</span>
                                <a-input :value="selectedContract ? selectedContract.contractAmount : ''" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">累计回款金额</span>
                                <a-input :value="selectedContract ? (selectedContract.finCumulativeReceivedAmount || 0) + ' 元' : '0 元'" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">回款比例</span>
                                <a-input :value="selectedContract ? (selectedContract.finCumulativeReceivedRatio || '0') + '%' : '0%'" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <!-- 结算模式 -->
                    <a-row :gutter="16">
                        <a-col span="24">
                            <a-form-item :label-col="{ xs: { span: 3 }, sm: { span: 3 }, md: { span: 4 }, lg: { span: 4 } }" :wrapper-col="{ xs: { span: 18 }, sm: { span: 18 }, md: { span: 16 }, lg: { span: 16 } }">
                                <span class="required" slot="label">结算模式</span>
                                <a-radio-group v-model="settlementMode">
                                    <a-radio v-for="item in settlementModeDict" :key="item.value" :value="item.value">{{ item.name }}</a-radio>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>

                <!-- 选择回款记录 -->
                <div class="title">
                    <img :src="iconReceipt" alt="" style="width: 20px; height: 20px; margin-right: 8px; vertical-align: middle;" />
                    选择回款记录
                </div>
                <div class="wrapper">
                    <a-row>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <span class="required" slot="label">回款记录列表</span>
                                <div style="background-color: #fff">
                                    <a-table
                                        bordered
                                        :data-source="receiptList"
                                        :pagination="{ pageSize: 5 }"
                                        :row-selection="rowSelection"
                                        :customRow="customRow"
                                        row-key="id"
                                        :loading="receiptLoading"
                                    >
                                        <a-table-column title="状态" data-index="subpackagePaymentApprovalStatus" align="center">
                                            <template slot-scope="text">
                                                <DataDictFinder dict-type="subpackage_payment.subpackage_payment_approval_status" :dict-value="text" icon-type="tag" />
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="回款日期" data-index="chargeDate" />
                                        <a-table-column title="回款金额(元)" data-index="amount" align="right">
                                            <template slot-scope="text">
                                                {{ text }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="流水来源" data-index="source">
                                            <template slot-scope="text">
                                                {{ text }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="预扣审图费比例" data-index="preDeductRatio">
                                            <template slot-scope="text">
                                                {{ text != null ? text + '%' : '-' }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="预扣审图费金额" data-index="preDeductAmount" align="right">
                                            <template slot-scope="text">
                                                {{ text != null ? text : '-' }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="管理费比例" data-index="managementFeeRatio">
                                            <template slot-scope="text">
                                                {{ text != null ? text + '%' : '-' }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="管理费金额" data-index="managementFeeAmount" align="right">
                                            <template slot-scope="text">
                                                {{ text != null ? text : '-' }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="备注" data-index="remark" />
                                    </a-table>
                                </div>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">本次结算对应回款额</span>
                                <a-input-number
                                    :formatter="$inputNumberFormat"
                                    style="width: 100%"
                                    :min="0"
                                    v-decorator="['currentReceiptAmount']"
                                    disabled
                                />
                            </a-form-item>
                        </a-col>
<!--                        <a-col :lg="12" :md="12" :sm="24">-->
<!--                            <a-form-item>-->
<!--                                <span class="required" slot="label">回款日期</span>-->
<!--                                <a-input :value="selectedReceiptDates" disabled />-->
<!--                            </a-form-item>-->
<!--                        </a-col>-->
                    </a-row>
                </div>
                <div class="title">审图费分配详情</div>
                <div class="wrapper distribute-wrapper">


                    <!-- 预扣审图费模式 -->
                    <a-row v-if="settlementMode === 'pre_deduct'" :gutter="16">
                        <a-col span="12">
                            <a-form-item>
                                <span class="required" slot="label">预扣审图费比例</span>
                                <a-input-number
                                    v-model="distributeTotalRatio"
                                    style="width: calc(100% - 40px)"
                                    :min="0" :max="100"
                                    @change="calcDistributeTotalFee"
                                />
                                <span style="margin-left:8px">%</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="12">
                            <a-form-item label="预扣审图费">
                                <a-input-number v-model="distributeTotalFee" disabled style="max-width:250px;" />
                                <span style="margin-left:8px">元</span>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- 实扣审图费模式 -->
                    <a-row v-if="settlementMode === 'actual_deduct'" :gutter="16">
                        <a-col span="12">
                            <a-form-item label="审图费比例">
                                <a-input-number
                                    v-model="distributeTotalRatio"
                                    style="width: calc(100% - 40px)"
                                    :min="0" :max="100"
                                    @change="calcDistributeTotalFee"
                                />
                                <span style="margin-left:8px">%</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="12">
                            <a-form-item label="审图费">
                                <a-input-number v-model="distributeTotalFee" disabled style="max-width:250px;" />
                                <span style="margin-left:8px">元</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="12">
                            <a-form-item label="已预扣审图费">
                                <a-input-number v-model="alreadyPreDeductAmount" disabled style="width: calc(100% - 40px)" />
                                <span style="margin-left:8px">元</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="12">
                            <a-form-item label="历史预扣审图费">
                                <a-input-number v-model="historyPreDeductAmount" style="width: calc(100% - 40px)" />
                                <span style="margin-left:8px">元</span>
                                <div style="color:#ff4d4f;font-size:12px;margin-top:4px;line-height:1.5;">预扣款项在系统中没有记录时填写，需要再附件中上传支撑材料</div>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- 折叠▲面板容器（仅实扣审图费模式显示） -->
                    <div class="distribute-div" v-if="settlementMode === 'actual_deduct'">
                            <div class="approvalFeesTitle">
                                <span>主办部门（10% / {{ distributeHostDeptFee }}元）</span>
                                <a-button type="link" @click="toggleCollapse('hostDept')">{{ activeCollapseKeys.includes('hostDept') ? '折叠▲' : '展开▼' }}</a-button>
                            </div>
                            <div class="distribute-block" v-show="activeCollapseKeys.includes('hostDept')">
                                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                                    <span style="font-weight:500;">参与分配部门</span>
                                    <span :style="{color: hostDeptRatioSum === 100 ? '#52c41a' : '#ff4d4f'}">百分比合计：{{ hostDeptRatioSum }}%</span>
                                </div>
                                <div v-for="(item, idx) in distributeHostDeptList" :key="idx" class="distribute-row">
                                    <a-tag v-if="item.deptName" :color="item.instituteType === 'prod' ? 'blue' : 'orange'" style="margin-right:4px">
                                        {{ item.instituteType === 'prod' ? '总院' : '分院' }}
                                    </a-tag>
                                    <a-select v-model="item.deptName" placeholder="部门名称" show-search :filter-option="$selectFilterOption" style="width:250px;max-width: 300px" @change="(val) => onSelectHostDept(val, idx)">
                                        <a-select-option v-for="org in organizationList" :key="org.id" :value="org.uniqueName">{{ org.uniqueName }}</a-select-option>
                                    </a-select>
                                    <a-input-number v-model="item.ratio" :min="0" :max="100" @change="calcDistributeAll" class="num-input" />
                                    <span>%</span>
                                    <a-input-number v-model="item.amount" disabled class="num-input" />
                                    <span>元</span>
                                    <a-space>
                                        <a-button icon="plus" @click="addDistributeRow('hostDept')" size="small" />
                                        <a-button icon="minus" @click="delDistributeRow('hostDept', idx)" size="small" danger />
                                    </a-space>
                                </div>
                            </div>
                            <div class="approvalFeesTitle">
                                <span>设计负责人（25% / {{ distributeDesignLeaderFee }}元）</span>
                                <a-button type="link" @click="toggleCollapse('designLeader')">{{ activeCollapseKeys.includes('designLeader') ? '折叠▲' : '展开▼' }}</a-button>
                            </div>
                            <div class="distribute-block" v-show="activeCollapseKeys.includes('designLeader')">
                                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                                    <span style="font-weight:500;flex:1">参与分配人员</span>
                                    <span :style="{color: designLeaderRatioSum === 100 ? '#52c41a' : '#ff4d4f'}">百分比合计：{{ designLeaderRatioSum }}%</span>
                                </div>
                                <div v-for="(item, idx) in distributeDesignLeaderList" :key="idx" class="distribute-row">
                                    <a-tag v-if="item.userName" :color="item.instituteType === 'prod' ? 'blue' : 'orange'" style="margin-right:4px">
                                        {{ item.instituteType === 'prod' ? '总院' : '分院' }}
                                    </a-tag>
                                    <EmployeeSelectorAll @change="(arr) => onSelectDesignLeader(arr, idx)">
                                        <a-button style="width:250px;max-width: 300px">
                                            <span v-if="item.orgName">{{ item.orgName }}-</span>
                                            <span v-if="item.userName">{{ item.userName }}</span>
                                            <span v-else>请选择人员</span>
                                        </a-button>

                                    </EmployeeSelectorAll>

                                    <a-input-number v-model="item.ratio" :min="0" :max="100" @change="calcDistributeAll" class="num-input" />
                                    <span>%</span>
                                    <a-input-number v-model="item.amount" disabled class="num-input" />
                                    <span>元</span>
                                    <a-space>
                                        <a-button icon="plus" @click="addDistributeRow('designLeader')" size="small" />
                                        <a-button icon="minus" @click="delDistributeRow('designLeader', idx)" size="small" danger />
                                    </a-space>
                                </div>
                            </div>
                        <div>
                            <div class="approvalFeesTitle">
                                <span>剩余占比/分配数值（65% / {{ distributeRestTotalFee }}元）</span>
                                <span :style="{color: restDeptRatioSum === 100 ? '#52c41a' : '#ff4d4f', marginLeft: '16px'}">专业百分比合计：{{ restDeptRatioSum }}%</span>
                                <a-button type="link" @click="toggleCollapse('rest')">{{ activeCollapseKeys.includes('rest') ? '折叠▲' : '展开▼' }}</a-button>
                            </div>
                            <!-- 增加专业 -->
                            <div style="margin:16px 0">
                                <a-button type="primary" icon="plus" @click="plus">增加专业</a-button>
                            </div>

                            <div class="distribute-block" v-show="activeCollapseKeys.includes('rest')">
                                <div v-for="(dept, dIdx) in distributeRestDeptList" :key="dIdx" style="margin-bottom:16px;padding-bottom:16px;border-bottom:1px dashed #e8e8e8">
                                    <div class="distribute-row" style="margin-bottom:8px">
                                        <span class="phase-tag">{{ dept.name }}</span>
                                        <a-input-number v-model="dept.ratio" :min="0" :max="100" @change="calcDistributeAll" style="width:100px" />
                                        <span>%</span>
                                        <span class="num-col" style="line-height:32px">{{ dept.amount }} 元</span>
                                        <a-space>
                                            <a-button icon="delete" @click="delRestDept(dIdx)" size="small" type="danger" />
                                        </a-space>
                                    </div>
                                    <!-- 固定人员分配环节 -->
                                    <div v-for="(role, rIdx) in dept.roleList" :key="rIdx" style="margin-bottom:12px;">
                                        <div style="display:flex;align-items:center;margin-bottom:4px;margin-left:24px;">
                                            <span style="font-weight:500;">{{ role.name }}（{{ role.fixedRatio }}% / {{ role.amount }}元）</span>
                                            <span :style="{color: getRolePersonRatioSum(dept, role) === 100 ? '#52c41a' : '#ff4d4f', marginLeft: '8px', fontSize: '12px'}">
                                                人员合计：{{ getRolePersonRatioSum(dept, role) }}%
                                            </span>
                                            <a-button style="margin-left: 10px;" v-if="role.name === '审定'" icon="delete"  @click="delRole(dIdx, rIdx)" size="small" type="danger" />
                                        </div>
                                        <div v-for="(person, pIdx) in role.personList" :key="pIdx" class="distribute-row" style="margin-left:48px">
                                            <a-tag v-if="person.userName" :color="person.instituteType === 'prod' ? 'blue' : 'orange'" style="margin-right:4px">
                                                {{ person.instituteType === 'prod' ? '总院' : '分院' }}
                                            </a-tag>
                                            <EmployeeSelectorAll @change="(arr) => onSelectRestPerson(arr, dIdx, rIdx, pIdx)">
                                                <a-button style="width:220px;max-width: 260px">
                                                    <span v-if="person.orgName">{{ person.orgName }}-</span>
                                                    <span v-if="person.userName">{{ person.userName }}</span>
                                                    <span v-else>请选择人员</span>
                                                </a-button>
                                            </EmployeeSelectorAll>
                                            <a-input-number v-model="person.ratio" :min="0" :max="100" @change="calcDistributeAll" class="num-input" />
                                            <span>%</span>
                                            <a-input-number v-model="person.amount" disabled class="num-input" />
                                            <span>元</span>
                                            <a-space>
                                                <a-button icon="plus" @click="addRestPerson(dIdx, rIdx)" size="small" />
                                                <a-button icon="minus" @click="delRestPerson(dIdx, rIdx, pIdx)" size="small" danger />
                                            </a-space>
                                        </div>
                                    </div>
                                    <!-- 增加审定按钮（审定被删除后显示） -->
                                    <div v-if="!dept.roleList.find(r => r.name === '审定')" style="margin-left:24px;margin-bottom:12px;">
                                        <a-button type="link" size="small" @click="addFinalReviewRole(dIdx)" style="color:#1890ff;">
                                            <a-icon type="plus" /> 增加审定
                                        </a-button>
                                    </div>
                                </div>
                            </div>
                        </div>


                    <!-- 底部合计行 -->
                    <a-row :gutter="16" style="margin-top:16px">
                        <a-col span="12">
                            <a-form-item label="总院审图费合计（应扣）">
                                <a-input-number v-model="distributeTotalDeduct" disabled  style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col span="12">
                            <a-form-item label="分院应得审图费合计">
                                <a-input-number v-model="distributeBranchGain" disabled  style="width:100%" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    </div>
                </div>

                <a-modal title="增加专业" :visible="visible" @cancel="cancel" @ok="ok">
                    <a-table
                        :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
                        :data-source="majorTypes"
                        bordered
                        :pagination="false"
                        :scroll="{ y: 240 }"
                    >
                        <a-table-column key="name" title="专业类型" data-index="name" />
                    </a-table>
                </a-modal>

                <!-- 付款信息 -->
                <div class="title">付款信息</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :span="24">
                            <a-form-item label="是否取得发票" :label-col="{ xs: { span: 3 }, sm: { span: 3 }, md: { span: 4 }, lg: { span: 4 } }" :wrapper-col="{ xs: { span: 18 }, sm: { span: 18 }, md: { span: 16 }, lg: { span: 16 } }">
                                <a-radio-group v-decorator="['isInvoiceObtained', { rules: [{ required: true, message: '请选择是否取得发票！' }] }]" button-style="solid">
                                    <a-radio :value="true">是</a-radio>
                                    <a-radio :value="false">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="管理费比例">
                                <a-input-number
                                    :formatter="$inputNumberFormat"
                                    style="width: calc(100% - 40px)"
                                    :min="0"
                                    :max="100"
                                    v-decorator="[
                                        'managementFeeRatio',
                                        { rules: [] },
                                    ]"
                                    @change="handleManagementFeeRatioChange"
                                />
                                <span style="margin-left: 8px">%</span>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span slot="label">管理费金额</span>
                                <a-input-number
                                    :formatter="$inputNumberFormat"
                                    style="width: 100%"
                                    :min="0"
                                    v-decorator="['managementFeeAmount']"
                                    disabled
                                />
                                <div style="color:#ff4d4f;font-size:12px;margin-top:4px;line-height:1.5;">管理费在结算中仅会扣除一次，在预扣阶段已扣除的回款，在实扣时不会重复扣除</div>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="其他扣款金额">
                                <a-input-number
                                    :formatter="$inputNumberFormat"
                                    style="width: 100%"
                                    :min="0"
                                    v-decorator="['otherDeductionAmount']"
                                    @change="handleOtherDeductionChange"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="其他扣款说明">
                                <a-input
                                    v-decorator="['otherDeductionDescription']"
                                    placeholder="请输入其他扣款说明"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">扣款合计</span>
                                <a-input-number
                                    :formatter="$inputNumberFormat"
                                    style="width: 100%"
                                    v-decorator="['totalDeduction']"
                                    disabled
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item>
                                <span class="required" slot="label">本次实际支付金额</span>
                                <a-input-number
                                    :formatter="$inputNumberFormat"
                                    style="width: 100%"
                                    :min="0"
                                    v-decorator="['actualPaymentAmount']"
                                    disabled
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="收款方银行账户名称">
                                <a-input
                                    v-decorator="[
                                        'receiverBankAccountName',
                                        { rules: [{ required: true, message: '请输入收款方银行账户名称！' }] },
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="收款方银行账号">
                                <a-input
                                    v-decorator="[
                                        'receiverBankAccount',
                                        { rules: [{ required: true, message: '请输入收款方银行账号！' }] },
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="收款方开户银行">
                                <a-input
                                    v-decorator="[
                                        'receiverBankName',
                                        { rules: [{ required: true, message: '请输入收款方开户银行！' }] },
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="付款说明">
                                <a-textarea
                                    :auto-size="{ minRows: 3 }"
                                    v-decorator="['paymentDescription', { rules: [{ required: true, message: '请输入付款说明！' }]}]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>

                <!-- 申请材料 -->
                <div class="title">申请材料</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-item label="上传">
                                <FileUpload @uploaded="uploaded">
                                    <a-button type="primary">附件上传</a-button>
                                </FileUpload>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="24" :md="24" :sm="24">
                            <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                <span class="required" slot="label">附件</span>
                                <div style="background-color: #fff">
                                    <a-table bordered :dataSource="fileList" :pagination="false">
                                        <a-table-column title="名称">
                                            <template slot-scope="text, record">
                                                <a :href="record.completePath" target="_blank">
                                                    {{ record.name || $getFileName(record.completePath) }}
                                                </a>
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="操作" align="center">
                                            <template slot-scope="text, record, index">
                                                <a href="#" @click.prevent="deleteFile(index)" class="danger">删除</a>
                                            </template>
                                        </a-table-column>
                                    </a-table>
                                </div>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>

                <div class="center">
                    <a-space>
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="loading"
                        >{{ resubmit ? "重新发起审批" : "发起审批" }}</a-button>
                        <a-button @click="$close($route.path)">关闭</a-button>
                    </a-space>
                </div>
            </a-form>
        </div>

        <CommentModal
            :visible="commentVisible"
            :title="commentTitle"
            @setVisible="setCommentVisible"
            @done="done"
        />
    </div>
</template>

<script>
import { submitApproval, resubmitReview, fetchPaymentApplicationDetail } from "@/api/finance/payment";
import { fetchIncomeDetailList } from "@/api/finance/income-detail";
import { fetchContractList } from "@/api/invoice";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import ContractSelector from "@/components/contract-selector";
import EmployeeSelectorAll from "@/components/employee-selector-all";
import CommentModal from "@/components/comment-modal";
import FileUpload from "@/components/file-upload";
import DataDictFinder from "@/components/data-dict-finder";
import Draft from "@/components/draft";
import organization from "@/mixins/organization";
import iconReceipt from "@/assets/approval2.png";

export default {
    name: "SubpackagePaymentBranchInstitute",
    mixins: [organization],
    components: {
        ContractSelector,
        EmployeeSelectorAll,
        CommentModal,
        FileUpload,
        DataDictFinder,
        Draft
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            selectedContract: {},
            receiptList: [],
            receiptLoading: false,
            selectedReceiptKeys: [],
            selectedReceiptList: [],
            fileList: [],
            commentVisible: false,
            commentTitle: "",
            resubmit: false,
            storageValue: {},
            iconReceipt,
            // 审图费分配数据
            settlementMode: '', // 结算模式: pre_deduct-预扣审图费 / actual_deduct-实扣审图费，默认不选择
            historyPreDeductAmount: 0, // 历史预扣审图费（实扣模式）
            activeCollapseKeys: ['hostDept','designLeader','rest'], // 默认全部展开▼
            distributeTotalRatio: 0, // 总审图费比例
            distributeTotalFee: 0, // 总审图费金额
// 1.主办部门 10% 分配列表
            distributeHostDeptFee:0,
            distributeHostDeptList: [
                { deptName: '', instituteType: 'prod', ratio: 0, amount: 0 }
            ],
// 2.设计负责人 25%
            distributeDesignLeaderFee:0,
            distributeDesignLeaderList: [
                { userName: '', userId: '', orgName: '', instituteType: 'prod', ratio: 0, amount: 0 }
            ],
// 3.剩余65%
            distributeRestTotalFee:0,
            distributeRestDeptList: [], // 初始为空，增加专业时填充
            // 固定人员分配比例配置
            defaultRoleConfig: [
                { name: '设计', ratio: 30 },
                { name: '专业负责', ratio: 25 },
                { name: '校核', ratio: 15 },
                { name: '审核', ratio: 15 },
                { name: '审定', ratio: 15 }
            ],
            // 删除审定后的比例配置
            roleConfigWithoutFinalReview: [
                { name: '设计', ratio: 33.75 },
                { name: '专业负责', ratio: 28.75 },
                { name: '校核', ratio: 18.75 },
                { name: '审核', ratio: 18.75 }
            ],
            visible: false,
            selectedRowKeys: [],
// 底部合计
            distributeTotalDeduct:0,
            distributeBranchGain:0
        };
    },
    computed: {
        ...mapState("auth", ["user"]),
        ...mapGetters("auth", ["department"]),
        ...mapState("approval", ["detail", "taskId", "instanceId"]),
        ...mapGetters("setting", ["findDataDict"]),
        ...mapState("organization", ["organizationList"]),
        majorTypes() {
            return this.findDataDict("majorTypes").map(item => ({ ...item, key: item.value }));
        },
        settlementModeDict() {
            return this.findDataDict("subpackage_payment.subpackage_payment_settle_mode");
        },
        // 已预扣审图费 = 回款列表中选择的状态为 pre_deduct_done（预扣结算完成）的预扣审图费金额合计（实扣模式展示）
        alreadyPreDeductAmount() {
            return this.selectedReceiptList
                .filter(item => item.subpackagePaymentApprovalStatus === 'pre_deduct_done')
                .reduce((sum, item) => this.accurateAdd(sum, Number(item.preDeductAmount) || 0), 0);
        },
        hostDeptHeader() {
            return '主办部门（10%|' + this.distributeHostDeptFee + '元）';
        },
        designLeaderHeader() {
            return '设计负责人（25%|' + this.distributeDesignLeaderFee + '元）';
        },
        restHeader() {
            return '剩余占比/分配数值 (65%|' + this.distributeRestTotalFee + '元)';
        },
        rowSelection() {
            return {
                type: 'checkbox',
                selectedRowKeys: this.selectedReceiptKeys,
                onChange: this.onSelectReceipt,
                getCheckboxProps: record => ({
                    props: {
                        disabled: !this.isReceiptSelectable(record)
                    }
                })
            };
        },
        // 已选回款记录合计金额
        totalReceiptAmount() {
            return this.selectedReceiptList.reduce((sum, item) => this.accurateAdd(sum, Number(item.amount) || 0), 0);
        },
        // 已选回款中状态为 not_applied(未申请) 的金额合计（预扣审图费模式按此计算）
        notAppliedReceiptAmount() {
            return this.selectedReceiptList
                .filter(item => item.subpackagePaymentApprovalStatus === 'not_applied')
                .reduce((sum, item) => this.accurateAdd(sum, Number(item.amount) || 0), 0);
        },
        // 用于计算管理费金额的未申请回款ID集合（逗号分隔）
        managementFeeIncomeDetailIds() {
            return this.selectedReceiptList
                .filter(item => item.subpackagePaymentApprovalStatus === 'not_applied')
                .map(item => item.id)
                .join(',');
        },
        // 用于计算审图费的未申请回款ID集合（逗号分隔）
        drawingReviewFeeIncomeDetailIds() {
            if (this.settlementMode === 'pre_deduct' || this.settlementMode === 'actual_deduct') {
                return this.managementFeeIncomeDetailIds;
            }
            return this.selectedReceiptList.map(item => item.id).join(',');
        },
        // 已选回款日期
        selectedReceiptDates() {
            return this.selectedReceiptList.map(item => item.chargeDate).join('，');
        },
        // 主办部门百分比总和
        hostDeptRatioSum() {
            return this.distributeHostDeptList.reduce((sum, item) => sum + (Number(item.ratio) || 0), 0);
        },
        // 设计负责人百分比总和
        designLeaderRatioSum() {
            return this.distributeDesignLeaderList.reduce((sum, item) => sum + (Number(item.ratio) || 0), 0);
        },
        // 主办部门有效数据百分比总和
        validHostDeptRatioSum() {
            return this.distributeHostDeptList.filter(item => item.deptName).reduce((sum, item) => sum + (Number(item.ratio) || 0), 0);
        },
        // 设计负责人有效数据百分比总和
        validDesignLeaderRatioSum() {
            return this.distributeDesignLeaderList.filter(item => item.userName).reduce((sum, item) => sum + (Number(item.ratio) || 0), 0);
        },
        // 剩余占比-专业百分比总和
        restDeptRatioSum() {
            return this.distributeRestDeptList.reduce((sum, dept) => sum + (Number(dept.ratio) || 0), 0);
        }
    },
    watch: {
        // 回款变更重算分配
        selectedReceiptList() {
            this.$nextTick(() => {
                this.calculateDeductions();
                this.calcDistributeTotalFee();
            });
        },
        // 结算模式切换重算分配（预扣模式仅按未申请回款金额计算）
        settlementMode() {
            this.$nextTick(() => {
                // 清除不符合当前结算模式勾选规则的回款记录
                const rows = this.selectedReceiptList.filter(item => this.isReceiptSelectable(item));
                const keys = rows.map(item => item.id);
                if (keys.length !== this.selectedReceiptKeys.length) {
                    this.selectedReceiptKeys = keys;
                    this.selectedReceiptList = rows;
                    this.onSelectReceipt(keys, rows);
                }
                this.calcDistributeTotalFee();
            });
        },
        distributeTotalRatio(val){
            this.calculateDeductions();
        },
        // 历史预扣审图费变化后重算分配（实扣模式）
        historyPreDeductAmount() {
            this.$nextTick(() => {
                this.calcDistributeAll();
            });
        }
    },
    mounted() {
        // 首次加载时也检查是否需要回显
        this.checkAndLoadData();
        this.$nextTick(() => {
            this.calcDistributeTotalFee();
        });
    },
    activated() {
        // keep-alive 激活时检查
        this.checkAndLoadData();
    },
    methods: {
        ...mapActions("approval", ["getDetail"]),
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        // 计算某个专业某个角色的人员百分比总和
        getRolePersonRatioSum(dept, role) {
            if (!dept.roleList) return 0;
            const foundRole = dept.roleList.find(r => r.name === role.name);
            if (!foundRole || !foundRole.personList) return 0;
            return foundRole.personList.reduce((sum, p) => sum + (Number(p.ratio) || 0), 0);
        },
        // 检查并加载数据
        checkAndLoadData() {
            const { query } = this.$route;
            const { taskId, instanceId } = query || {};
            console.log('checkAndLoadData 触发, query:', query);
            if (taskId && instanceId) {
                this.resubmit = true;
                this.setTaskId(taskId);
                this.setInstanceId(instanceId);
                console.log('开始获取审批详情...');
                this.getDetail().then(() => {
                    console.log('审批详情获取成功, detail:', this.detail);
                    // 从 businessKey 中获取 id
                    if (this.detail && this.detail.businessKey) {
                        const businessKey = this.detail.businessKey;
                        console.log('businessKey:', businessKey);
                        const id = businessKey.includes(':') ? businessKey.split(':')[1] : businessKey;
                        console.log('提取的 id:', id);
                        if (id) {
                            // 使用新接口获取详情数据
                            console.log('开始调用 loadPaymentDetail...');
                            this.loadPaymentDetail(id);
                        } else {
                            console.error('无法从 businessKey 中提取 id');
                        }
                    } else {
                        console.error('detail 或 businessKey 不存在');
                    }
                }).catch((err) => {
                    console.error('获取审批详情失败:', err);
                });
            } else {
                console.log('没有 taskId 或 instanceId，不是重新提交模式');
            }
        },
        // 草稿选择（保留但不实现功能）
        onSelectDraft(draft) {
            // 暂不支持草稿功能
        },
        customRow(record) {
            return {
                on: {
                    click: () => {
                        this.toggleSelectReceipt(record);
                    }
                }
            };
        },
        toggleSelectReceipt(record) {
            if (!this.isReceiptSelectable(record)) {
                this.$message.warning('当前结算模式下，该状态的回款记录不可勾选');
                return;
            }
            const keys = [...this.selectedReceiptKeys];
            const rows = [...this.selectedReceiptList];
            const index = keys.indexOf(record.id);
            if (index > -1) {
                keys.splice(index, 1);
                rows.splice(index, 1);
            } else {
                keys.push(record.id);
                rows.push(record);
            }
            this.onSelectReceipt(keys, rows);
        },
        // 判断回款记录是否可勾选（按结算模式限制）
        isReceiptSelectable(record) {
            if (!record) return false;
            const status = record.subpackagePaymentApprovalStatus;
            if (this.settlementMode === 'actual_deduct') {
                return status === 'not_applied' || status === 'pre_deduct_done';
            }
            if (this.settlementMode === 'pre_deduct') {
                return status === 'not_applied';
            }
            // 未选择结算模式时，仅允许未申请/预扣结算完成
            return status === 'not_applied' || status === 'pre_deduct_done';
        },
        onSelectContract(record) {
            this.selectedContract = record;
            this.form.setFieldsValue({
                contractCode: record.code,
                buyerName: record.partyAname,
                contractAmount: record.contractAmount,
                // 回填累计回款金额和回款比例
                finCumulativeReceivedAmount: record.finCumulativeReceivedAmount || 0,
                finCumulativeReceivedRatio: record.finCumulativeReceivedRatio || '0'
            });
            this.loadReceiptList(record.id);
            // 选择合同后计算审图费
            this.$nextTick(() => {
                this.calcDistributeTotalFee();
            });
        },
        loadReceiptList(contractId) {
            this.receiptLoading = true;
            const params = {
                contractId: contractId,
                pageNum: 1,
                pageSize: 50
            };

            fetchIncomeDetailList(params)
                .then((res) => {
                    if (res && res.list) {
                        this.receiptList = res.list;
                    } else {
                        this.receiptList = [];
                    }
                })
                .catch(() => {
                    this.receiptList = [];
                })
                .finally(() => {
                    this.receiptLoading = false;
                });
        },
        onSelectReceipt(selectedRowKeys, selectedRows) {
            const rows = (selectedRows || []).filter(item => this.isReceiptSelectable(item));
            this.selectedReceiptKeys = rows.map(item => item.id);
            this.selectedReceiptList = rows;
            this.form.setFieldsValue({
                currentReceiptAmount: this.roundTo2Decimals(this.totalReceiptAmount) || null
            });
            this.calculateDeductions();
            this.calcDistributeTotalFee();
        },
        calculateDeductions() {
            // 统一计算入口：扣款合计 / 本次实际支付金额
            this.calcTotalDeduction();
        },
        // 计算扣款合计与本次实际支付金额（各变更入口统一调用）
        // 预扣审图费模式：扣款合计 = 预扣审图费 + 管理费金额 + 其他扣款金额
        // 实扣审图费模式：扣款合计 = 总院审图费合计（应扣）+ 管理费金额 + 其他扣款金额 - 已预扣审图费 - 历史预扣审图费
        calcTotalDeduction(managementFeeRatioVal, otherDeductionAmountVal) {
            const values = this.form.getFieldsValue();
            const currentReceiptAmount = parseFloat(values.currentReceiptAmount || 0);
            const managementFeeRatio = managementFeeRatioVal != null
                ? parseFloat(managementFeeRatioVal || 0)
                : parseFloat(values.managementFeeRatio || 0);
            const otherDeductionAmount = otherDeductionAmountVal != null
                ? parseFloat(otherDeductionAmountVal || 0)
                : parseFloat(values.otherDeductionAmount || 0);

            // 使用高精度计算库避免精度问题
            // 管理费金额 = 未申请(not_applied)回款金额合计 * 管理费比例
            const managementFeeAmount = this.accurateMultiply(this.notAppliedReceiptAmount, managementFeeRatio / 100);

            let totalDeduction;
            if (this.settlementMode === 'pre_deduct') {
                // 扣款合计 = 预扣审图费 + 管理费金额 + 其他扣款金额
                const preDeductFee = parseFloat(this.distributeTotalFee || 0);
                totalDeduction = this.accurateAdd(
                    this.accurateAdd(preDeductFee, managementFeeAmount),
                    otherDeductionAmount
                );
            } else {
                // 扣款合计 = 总院审图费合计（应扣）+ 管理费金额 + 其他扣款金额 - 已预扣审图费 - 历史预扣审图费
                const headquartersDrawingReviewFee = parseFloat(this.distributeTotalDeduct || 0);
                totalDeduction = this.accurateSubtract(
                    this.accurateAdd(
                        this.accurateAdd(headquartersDrawingReviewFee, managementFeeAmount),
                        otherDeductionAmount
                    ),
                    this.accurateAdd(
                        Number(this.alreadyPreDeductAmount) || 0,
                        Number(this.historyPreDeductAmount) || 0
                    )
                );
            }

            const actualPaymentAmount = this.accurateSubtract(currentReceiptAmount, totalDeduction);

            this.form.setFieldsValue({
                managementFeeAmount: this.roundTo2Decimals(managementFeeAmount),
                totalDeduction: this.roundTo2Decimals(totalDeduction),
                actualPaymentAmount: this.roundTo2Decimals(actualPaymentAmount)
            });
        },
        handleManagementFeeRatioChange(value) {
            // 直接传递新值进行计算，避免获取旧值的问题
            this.$nextTick(() => {
                this.calcTotalDeduction(value);
            });
        },
        handleOtherDeductionChange(value) {
            // 直接传递新值进行计算，避免获取旧值的问题
            this.$nextTick(() => {
                this.calcTotalDeduction(null, value);
                // 刷新分配金额
                this.calcDistributeTotalFee();
            });
        },
        // 高精度计算方法
        // 构建审图费分配列表
        buildDrawingReviewAllocations() {
            const allocations = [];
            let sortOrder = 0;

            // 人员类型映射
            const personnelTypeMap = {
                '设计': 'DESIGN',
                '专业负责': 'PROFESSION_RESPONSIBLE',
                '校核': 'CHECK',
                '审核': 'REVIEW',
                '审定': 'APPROVE'
            };

            // instituteType 映射
            const convertInstituteType = (type) => {
                if (type === 'prod') return 'HEADQUARTERS';
                if (type === 'branch') return 'BRANCH';
                return type || '';
            };

            // 1. 主办部门
            const hostDeptDetails = this.distributeHostDeptList
                .filter(item => item.deptName)
                .map((item, idx) => ({
                    amount: item.amount || 0,
                    deptName: item.deptName,
                    instituteType: convertInstituteType(item.instituteType),
                    ratio: item.ratio || 0,
                    sortOrder: idx + 1
                }));

            if (hostDeptDetails.length > 0) {
                allocations.push({
                    allocationType: 'HOST_DEPT',
                    amount: this.distributeHostDeptFee,
                    details: hostDeptDetails,
                    ratio: 10, // 主办部门固定10%
                    sortOrder: ++sortOrder
                });
            }

            // 2. 设计负责人
            const designLeaderDetails = this.distributeDesignLeaderList
                .filter(item => item.userName)
                .map((item, idx) => ({
                    amount: item.amount || 0,
                    deptName: item.orgName,
                    instituteType: convertInstituteType(item.instituteType),
                    ratio: item.ratio || 0,
                    sortOrder: idx + 1,
                    userId: item.userId,
                    userName: item.userName
                }));

            if (designLeaderDetails.length > 0) {
                allocations.push({
                    allocationType: 'DESIGN_LEADER',
                    amount: this.distributeDesignLeaderFee,
                    details: designLeaderDetails,
                    ratio: 25, // 设计负责人固定25%
                    sortOrder: ++sortOrder
                });
            }

            // 3. 专业分配
            this.distributeRestDeptList.forEach((dept, deptIdx) => {
                const types = [];

                dept.roleList.forEach((role, roleIdx) => {
                    const details = role.personList
                        .filter(person => person.userName)
                        .map((person, personIdx) => ({
                            amount: person.amount || 0,
                            deptName: person.orgName,
                            instituteType: convertInstituteType(person.instituteType),
                            ratio: person.ratio || 0,
                            sortOrder: personIdx + 1,
                            userId: person.userId,
                            userName: person.userName
                        }));

                    if (details.length > 0) {
                        types.push({
                            amount: role.amount || 0,
                            details: details,
                            personnelType: personnelTypeMap[role.name] || role.name,
                            ratio: role.fixedRatio || 0,
                            sortOrder: roleIdx + 1
                        });
                    }
                });

                if (types.length > 0) {
                    allocations.push({
                        allocationType: 'PROFESSION',
                        amount: dept.amount || 0,
                        professionType: dept.name,
                        ratio: dept.ratio || 0,
                        sortOrder: ++sortOrder,
                        types: types
                    });
                }
            });

            return allocations;
        },
        accurateMultiply(num1, num2) {
            // 使用字符串方式进行高精度乘法
            const str1 = num1.toString();
            const str2 = num2.toString();
            const decimalPlaces1 = (str1.split('.')[1] || '').length;
            const decimalPlaces2 = (str2.split('.')[1] || '').length;
            const result = (num1 * Math.pow(10, decimalPlaces1)) * (num2 * Math.pow(10, decimalPlaces2)) / Math.pow(10, decimalPlaces1 + decimalPlaces2);
            return result;
        },
        accurateAdd(num1, num2) {
            // 使用字符串方式进行高精度加法
            const base = Math.pow(10, 10); // 使用10位小数精度
            return (Math.round(num1 * base) + Math.round(num2 * base)) / base;
        },
        accurateSubtract(num1, num2) {
            // 使用字符串方式进行高精度减法
            const base = Math.pow(10, 10); // 使用10位小数精度
            return (Math.round(num1 * base) - Math.round(num2 * base)) / base;
        },
        roundTo2Decimals(num) {
            return Math.round(num * 100) / 100;
        },
        // 按机构类型(prod-总院/branch-分院)累计分配金额，空值兜底为 branch
        accumulateInstituteAmounts(list, baseAmount) {
            let prodSum = 0;
            let branchSum = 0;
            (list || []).forEach(item => {
                const ratio = Number(item.ratio) || 0;
                item.amount = this.roundTo2Decimals(
                    this.accurateMultiply(baseAmount, ratio / 100)
                );
                const type = item.instituteType || 'prod';
                if (type === 'prod') {
                    prodSum = this.accurateAdd(prodSum, item.amount);
                } else {
                    branchSum = this.accurateAdd(branchSum, item.amount);
                }
            });
            return { prod: prodSum, branch: branchSum };
        },

        uploaded(fileList) {
            // FileUpload 组件返回的是文件数组
            if (Array.isArray(fileList)) {
                this.fileList = [...this.fileList, ...fileList];
            } else if (fileList) {
                // 如果返回的是单个文件对象
                this.fileList.push(fileList);
            }
        },
        deleteFile(index) {
            this.fileList.splice(index, 1);
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    if (!this.settlementMode) {
                        this.$message.warning('请选择结算模式');
                        return;
                    }
                    if (this.settlementMode === 'pre_deduct' && (this.distributeTotalRatio == null || this.distributeTotalRatio === '')) {
                        this.$message.warning('请输入预扣审图费比例');
                        return;
                    }
                    if (!this.selectedContract.id) {
                        this.$message.warning('请选择合同');
                        return;
                    }
                    if (!this.selectedReceiptList || this.selectedReceiptList.length === 0) {
                        this.$message.warning('请选择回款记录');
                        return;
                    }
                    if (!this.fileList || this.fileList.length === 0) {
                        this.$message.warning('请上传附件');
                        return;
                    }

                    // 校验主办部门百分比总和（有填写部门名称时才校验）
                    const validHostDeptList = this.distributeHostDeptList.filter(item => item.deptName);
                    if (validHostDeptList.length > 0) {
                        const hostSum = validHostDeptList.reduce((sum, item) => sum + (Number(item.ratio) || 0), 0);
                        if (hostSum !== 100) {
                            this.$message.warning('主办部门分配百分比总和必须为100%');
                            return;
                        }
                    }

                    // 校验设计负责人百分比总和（有填写人员时才校验）
                    const validDesignLeaderList = this.distributeDesignLeaderList.filter(item => item.userName);
                    if (validDesignLeaderList.length > 0) {
                        const leaderSum = validDesignLeaderList.reduce((sum, item) => sum + (Number(item.ratio) || 0), 0);
                        if (leaderSum !== 100) {
                            this.$message.warning('设计负责人分配百分比总和必须为100%');
                            return;
                        }
                    }

                    // 校验专业百分比合计
                    if (this.distributeRestDeptList.length > 0 && this.restDeptRatioSum !== 100) {
                        this.$message.warning('专业百分比合计必须为100%');
                        return;
                    }

                    // 校验每个专业每个角色的人员百分比总和
                    for (const dept of this.distributeRestDeptList) {
                        if (dept.roleList) {
                            for (const role of dept.roleList) {
                                const rolePersonRatioSum = role.personList.reduce((sum, p) => sum + (Number(p.ratio) || 0), 0);
                                if (rolePersonRatioSum !== 100) {
                                    this.$message.warning(`${dept.name} - ${role.name} 的人员分配百分比总和必须为100%`);
                                    return;
                                }
                            }
                        }
                    }

                    this.loading = true;

                    // 构建审图费分配列表
                    const drawingReviewAllocations = this.buildDrawingReviewAllocations();

                    const data = {
                        ...values,
                        // 基本信息
                        applicantId: this.user.uuid,
                        applicantName: this.user.userName,
                        deptId: this.department.deptId,
                        deptName: this.department.deptUniqueName,

                        // 合同信息
                        contractId: this.selectedContract.id,
                        contract: JSON.stringify(this.selectedContract),
                        ownerName: this.selectedContract.partyAname,

                        // 回款信息（使用收入明细income_detail）
                        incomeDetailId: this.selectedReceiptList[0].id,
                        incomeDetailIds: this.selectedReceiptList.map(item => item.id).join(','),
                        receiptAmount: this.roundTo2Decimals(this.totalReceiptAmount),
                        receiptDate: this.selectedReceiptList.map(item => item.chargeDate).join(','),

                        // 扣款信息
                        settlementMode: this.settlementMode,
                        alreadyPreDeductAmount: this.alreadyPreDeductAmount,
                        historyPreDeductAmount: this.historyPreDeductAmount,
                        managementFeeRatio: values.managementFeeRatio,
                        managementFeeAmount: values.managementFeeAmount,
                        managementFeeIncomeDetailIds: this.managementFeeIncomeDetailIds,
                        drawingReviewFeeIncomeDetailIds: this.drawingReviewFeeIncomeDetailIds,
                        drawingReviewFeeRatio: this.distributeTotalRatio,
                        drawingReviewFeeAmount: this.distributeTotalFee,
                        otherDeductionAmount: values.otherDeductionAmount,
                        otherDeductionDescription: values.otherDeductionDescription,
                        totalDeduction: values.totalDeduction,
                        actualPaymentAmount: values.actualPaymentAmount,
                        currentReceiptAmount: values.currentReceiptAmount,

                        // 镜像历史数据
                        snapshotContractAmount: this.selectedContract.contractAmount,
                        snapshotCumulativeCollectionAmount: this.selectedContract.finCumulativeReceivedAmount || 0,
                        snapshotCollectionRatio: this.selectedContract.finCumulativeReceivedRatio || '0',
                        snapshotCumulativePaymentAmount: values.actualPaymentAmount,
                        snapshotCumulativePaymentRatio: this.calculateCumulativePaymentRatio(),

                        // 是否取得发票（布尔值）
                        isInvoiceObtained: values.isInvoiceObtained,

                        // 收款方信息
                        receiverBankAccountName: values.receiverBankAccountName,
                        receiverBankAccount: values.receiverBankAccount,
                        receiverBankName: values.receiverBankName,

                        // 付款说明
                        paymentDescription: values.paymentDescription,

                        // 申请资料
                        applicationMaterials: this.fileList.map(item => item.id).join(','),
                        files: this.fileList,

                        // 支付类型
                        paymentType: 'branch_institute',

                        // 审图费分配详情
                        drawingReviewAllocations: drawingReviewAllocations,
                        headquartersDrawingReviewFee: this.distributeTotalDeduct,
                        branchDrawingReviewFee: this.distributeBranchGain
                    };

                    // 根据是否重新提交选择不同的接口
                    const apiCall = this.resubmit ? resubmitReview : submitApproval;

                    // 如果是重新提交，需要带上id
                    if (this.resubmit && this.detail && this.detail.businessKey) {
                        const businessKey = this.detail.businessKey;
                        const id = businessKey.includes(':') ? businessKey.split(':')[1] : businessKey;
                        data.id = id;
                    }

                    if (this.resubmit) {
                        // 重新提交：弹出审批意见框，让用户填写备注
                        this.storageValue = data;
                        this.commentTitle = '重新发起审批';
                        this.commentVisible = true;
                    } else {
                        // 首次提交：直接调用
                        apiCall(data)
                            .then((res) => {
                                this.$message.success('提交成功');
                                this.$close(this.$route.path);
                            })
                            .catch(() => {
                                this.$message.error('提交失败');
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                }
            });
        },
        loadPaymentDetail(id) {
            console.log('loadPaymentDetail 被调用, id:', id);
            // 使用新接口获取付款申请详情
            fetchPaymentApplicationDetail(id).then((res) => {
                console.log('fetchPaymentApplicationDetail 返回数据:', res);
                if (res) {
                    this.fillFormData(res);
                } else {
                    console.error('fetchPaymentApplicationDetail 返回空数据');
                }
            }).catch((err) => {
                console.error('加载付款申请详情失败:', err);
                this.$message.error('加载数据失败');
            });
        },
        fillFormData(data) {
            console.log('fillFormData 接收到的数据:', data);

            // 解析 extra 数据
            let extraData = data;
            if (typeof data === 'string') {
                try {
                    extraData = JSON.parse(data);
                } catch (e) {
                    console.error('解析 extra 数据失败:', e);
                    return;
                }
            }

            // 1. 加载合同信息：调用合同列表接口自动选中当前回显的合同，其余数据在选中完成后回填
            if (extraData.contractId) {
                this.loadContractAndSelect(extraData);
            } else {
                this.fillRestFormData(extraData);
            }
        },
        // 编辑/详情回显：调用 fetchContractList 查询合同列表并自动选中当前回显的项目，
        // 等效于用户在 ContractSelector 中点击该行 → $emit("change", record) → onSelectContract 的完整流程
        loadContractAndSelect(extraData) {
            // 接口未命中/请求失败时的兜底：用详情数据重建合同对象（与原回显逻辑一致）
            const fallbackContract = {
                id: extraData.contractId,
                name: extraData.contractName || extraData.name,
                code: extraData.contractCode || extraData.code,
                partyAname: extraData.ownerName || extraData.partyAname,
                contractAmount: extraData.contractAmount || extraData.snapshotContractAmount,
                // 回填累计回款金额和回款比例
                finCumulativeReceivedAmount: extraData.finCumulativeReceivedAmount || extraData.snapshotCumulativeCollectionAmount || 0,
                finCumulativeReceivedRatio: extraData.finCumulativeReceivedRatio || extraData.snapshotCollectionRatio || '0'
            };
            const params = { pageNum: 1, pageSize: 50 };
            const keyword = extraData.contractCode || extraData.code || extraData.contractName || extraData.name;
            if (keyword) {
                params.keyWord = keyword;
            }
            fetchContractList(params).then((res) => {
                const list = (res && res.list) || [];
                const record = list.find(item => item.id === extraData.contractId);
                // 命中：选中接口返回的最新合同数据（与手动选择一致）；未命中：回退详情数据
                this.onSelectContract(record || fallbackContract);
                // 2. 回显已选择的回款记录
                this.restoreSelectedReceipts(extraData);
                // 3. 回填其余表单数据
                this.fillRestFormData(extraData);
            }).catch(() => {
                this.onSelectContract(fallbackContract);
                this.restoreSelectedReceipts(extraData);
                this.fillRestFormData(extraData);
            });
        },
        // 设置已选择的回款记录 - 优先从 incomeDetail / incomeDetailList 获取
        restoreSelectedReceipts(extraData) {
            const incomeDetailList = extraData.incomeDetailList || (extraData.incomeDetail ? [extraData.incomeDetail] : []);
            if (incomeDetailList.length > 0) {
                // 如果有完整的 incomeDetail 列表，直接使用
                const list = incomeDetailList.map(item => {
                    if (typeof item === 'string') {
                        try {
                            return JSON.parse(item);
                        } catch (e) {
                            console.error('解析 incomeDetail 数据失败:', e);
                            return null;
                        }
                    }
                    return item;
                }).filter(Boolean);

                this.selectedReceiptList = list;
                this.selectedReceiptKeys = list.map(item => item.id);
                this.form.setFieldsValue({
                    currentReceiptAmount: this.roundTo2Decimals(list.reduce((sum, item) => this.accurateAdd(sum, Number(item.amount) || 0), 0))
                });
            } else if (extraData.incomeDetailId) {
                // 等待回款列表加载完成后选择对应的记录
                setTimeout(() => {
                    const ids = String(extraData.incomeDetailId).split(',').filter(Boolean);
                    const receipts = this.receiptList.filter(item => ids.includes(item.id));
                    if (receipts.length > 0) {
                        this.selectedReceiptList = receipts;
                        this.selectedReceiptKeys = receipts.map(item => item.id);
                        this.form.setFieldsValue({
                            currentReceiptAmount: this.roundTo2Decimals(receipts.reduce((sum, item) => this.accurateAdd(sum, Number(item.amount) || 0), 0))
                        });
                    }
                }, 500);
            }
        },
        // 回填其余表单字段与审图费分配详情
        fillRestFormData(extraData) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.form.setFieldsValue({
                        isInvoiceObtained: extraData.isInvoiceObtained,
                        managementFeeRatio: extraData.managementFeeRatio,
                        managementFeeAmount: extraData.managementFeeAmount,
                        otherDeductionAmount: extraData.otherDeductionAmount,
                        otherDeductionDescription: extraData.otherDeductionDescription,
                        totalDeduction: extraData.totalDeduction,
                        actualPaymentAmount: extraData.actualPaymentAmount,
                        receiverBankAccountName: extraData.receiverBankAccountName,
                        receiverBankAccount: extraData.receiverBankAccount,
                        receiverBankName: extraData.receiverBankName,
                        paymentDescription: extraData.paymentDescription
                    });

                  // 如果有附件，回显附件列表
                  if (extraData.applicationMaterials) {
                    // 处理附件回显逻辑（如果需要）
                    console.log('附件IDs:', extraData.applicationMaterials);
                  }
                  if (extraData.applicationMaterialFileList && Array.isArray(extraData.applicationMaterialFileList)) {
                    this.fileList = extraData.applicationMaterialFileList;
                  }
                  // 5. 回显审图费分配详情
                  if (extraData.settlementMode) {
                    this.settlementMode = extraData.settlementMode;
                  }
                  if (extraData.historyPreDeductAmount != null) {
                    this.historyPreDeductAmount = extraData.historyPreDeductAmount;
                  }
                  if (extraData.drawingReviewAllocations && Array.isArray(extraData.drawingReviewAllocations)) {
                    this.distributeTotalRatio = extraData.drawingReviewFeeRatio || 0;
                    this.calcDistributeTotalFee();
                    this.fillDrawingReviewAllocations(extraData.drawingReviewAllocations);
                  }
                }, 500);
            });
        },
        // 回显审图费分配详情
        fillDrawingReviewAllocations(allocations) {
          this.distributeHostDeptList = [];
          this.distributeDesignLeaderList = [];
          this.distributeRestDeptList = [];

          for (const alloc of allocations) {
            if (alloc.allocationType === 'HOST_DEPT') {
              this.distributeHostDeptList = alloc.details.map(d => ({
                deptName: d.deptName,
                instituteType: d.instituteType === 'HEADQUARTERS' ? 'prod' : 'branch',
                ratio: d.ratio || 0,
                amount: d.amount || 0
              }));
            } else if (alloc.allocationType === 'DESIGN_LEADER') {
              this.distributeDesignLeaderList = alloc.details.map(d => ({
                userName: d.userName || '',
                userId: d.userId || '',
                orgName: d.deptName,
                instituteType: d.instituteType === 'HEADQUARTERS' ? 'prod' : 'branch',
                ratio: d.ratio || 0,
                amount: d.amount || 0
              }));
            } else if (alloc.allocationType === 'PROFESSION') {
              const roleList = (alloc.types || []).map(t => ({
                name: this.getRoleNameFromPersonnelType(t.personnelType),
                fixedRatio: t.ratio || 0,
                amount: t.amount || 0,
                personList: (t.details || []).map(d => ({
                  userName: d.userName || '',
                  userId: d.userId || '',
                  orgName: d.deptName,
                  instituteType: d.instituteType === 'HEADQUARTERS' ? 'prod' : 'branch',
                  ratio: d.ratio || 0,
                  amount: d.amount || 0
                }))
              }));

              this.distributeRestDeptList.push({
                name: alloc.professionType,
                ratio: alloc.ratio || 0,
                amount: alloc.amount || 0,
                roleList: roleList
              });
            }
          }
          this.calcDistributeAll();
        },
        getRoleNameFromPersonnelType(type) {
          const map = {
            'DESIGN': '设计',
            'PROFESSION_RESPONSIBLE': '专业负责',
            'CHECK': '校核',
            'REVIEW': '审核',
            'APPROVE': '审定'
          };
          return map[type] || type || '';
        },
        calculateCumulativePaymentRatio() {
            // 计算累计支付比例：本次实际支付金额 / 合同金额
            const actualPaymentAmount = parseFloat(this.form.getFieldValue('actualPaymentAmount') || 0);
            const contractAmount = parseFloat(this.selectedContract.contractAmount || 0);
            if (contractAmount > 0) {
                return ((actualPaymentAmount / contractAmount) * 100).toFixed(2);
            }
            return '0';
        },
        // 审批意见弹窗设置
        setCommentVisible(visible) {
            this.commentVisible = visible;
        },

        done(comment) {
            // 这里处理审批提交逻辑，将备注放入请求中
            const apiCall = this.resubmit ? resubmitReview : submitApproval;
            const data = { ...this.storageValue, comment };

            apiCall(data)
                .then((res) => {
                    this.$message.success('重新提交成功');
                    this.$close(this.$route.path);
                })
                .catch(() => {
                    this.$message.error('重新提交失败');
                })
                .finally(() => {
                    this.loading = false;
                });
        },


        // 计算审图费总金额
        calcDistributeTotalFee() {
            // 预扣/实扣审图费模式：仅按所选回款中状态为 not_applied(未申请) 的金额合计计算
            const receiptAmount = (this.settlementMode === 'pre_deduct' || this.settlementMode === 'actual_deduct')
                ? this.notAppliedReceiptAmount
                : this.totalReceiptAmount;
            const ratio = Number(this.distributeTotalRatio || 0);
            this.distributeTotalFee = this.roundTo2Decimals(this.accurateMultiply(receiptAmount, ratio / 100));
            this.calcDistributeAll();
        },
        // 按三段比例递归计算分配金额及总院/分院合计
        calcDistributeAll() {
            // 实扣审图费模式：分配基数 = 审图费 + 已预扣审图费 + 历史预扣审图费
            let totalFee = Number(this.distributeTotalFee) || 0;
            if (this.settlementMode === 'actual_deduct') {
                totalFee = this.accurateAdd(
                    totalFee,
                    this.accurateAdd(
                        Number(this.alreadyPreDeductAmount) || 0,
                        Number(this.historyPreDeductAmount) || 0
                    )
                );
            }
            let prodTotal = 0; // 总院金额累计
            let branchTotal = 0; // 分院金额累计

            // 1. 主办部门（固定10%）
            this.distributeHostDeptFee = this.roundTo2Decimals(this.accurateMultiply(totalFee, 0.1));
            const hostResult = this.accumulateInstituteAmounts(
                this.distributeHostDeptList, this.distributeHostDeptFee
            );
            prodTotal = this.accurateAdd(prodTotal, hostResult.prod);
            branchTotal = this.accurateAdd(branchTotal, hostResult.branch);

            // 2. 设计负责人（固定25%）
            this.distributeDesignLeaderFee = this.roundTo2Decimals(this.accurateMultiply(totalFee, 0.25));
            const leaderResult = this.accumulateInstituteAmounts(
                this.distributeDesignLeaderList, this.distributeDesignLeaderFee
            );
            prodTotal = this.accurateAdd(prodTotal, leaderResult.prod);
            branchTotal = this.accurateAdd(branchTotal, leaderResult.branch);

            // 3. 剩余专业分配（固定65%）— 逐级下钻：专业→角色→人员
            this.distributeRestTotalFee = this.roundTo2Decimals(this.accurateMultiply(totalFee, 0.65));
            this.distributeRestDeptList.forEach(dept => {
                dept.amount = this.roundTo2Decimals(
                    this.accurateMultiply(this.distributeRestTotalFee, (dept.ratio || 0) / 100)
                );
                (dept.roleList || []).forEach(role => {
                    role.amount = this.roundTo2Decimals(
                        this.accurateMultiply(dept.amount, (role.fixedRatio || 0) / 100)
                    );
                    const personResult = this.accumulateInstituteAmounts(
                        role.personList, role.amount
                    );
                    prodTotal = this.accurateAdd(prodTotal, personResult.prod);
                    branchTotal = this.accurateAdd(branchTotal, personResult.branch);
                });
            });

            // 四舍五入差值修正：确保 总院合计 + 分院合计 = 审图费，差值归入主办部门首个有效项
            const sumActual = this.accurateAdd(prodTotal, branchTotal);
            const diff = this.accurateSubtract(totalFee, sumActual);
            if (diff !== 0) {
                const target = this.distributeHostDeptList.find(
                    item => item.deptName
                );
                if (target) {
                    target.amount = this.roundTo2Decimals(this.accurateAdd(target.amount, diff));
                    if (target.instituteType === 'prod') {
                        prodTotal = this.accurateAdd(prodTotal, diff);
                    } else {
                        branchTotal = this.accurateAdd(branchTotal, diff);
                    }
                }
            }

            this.distributeTotalDeduct = this.roundTo2Decimals(prodTotal);
            this.distributeBranchGain = this.roundTo2Decimals(branchTotal);

            // 总院审图费合计（应扣）变化后联动重算扣款合计
            this.calculateDeductions();
        },
        // 主办部门选择部门
        onSelectHostDept(val, idx) {
            const item = this.distributeHostDeptList[idx];
            if (item) {
                const org = this.organizationList.find(o => o.uniqueName === val);
                item.instituteType = org ? (org.instituteType || 'prod') : 'prod';
                this.calcDistributeAll();
            }
        },
        // 设计负责人选择人员
        onSelectDesignLeader(arr, idx) {
            if (arr.length === 0) return;
            const obj = arr[0];
            const item = this.distributeDesignLeaderList[idx];
            if (item) {
                const org = this.organizationList.find(o => o.uniqueName === obj.deptUniqueName);
                item.userName = obj.name;
                item.userId = obj.userId;
                item.orgName = obj.deptUniqueName;
                item.instituteType = org ? (org.instituteType || obj.instituteType || 'branch') : (obj.instituteType || 'branch');
                this.calcDistributeAll();
            }
        },
        // 主办/负责人 增删行
        addDistributeRow(type) {
            if(type === 'hostDept'){
                this.distributeHostDeptList.push({ deptName:'', instituteType: 'prod', ratio:0, amount:0 });
            }else if(type === 'designLeader'){
                this.distributeDesignLeaderList.push({ userName:'', userId: '', orgName: '', instituteType: 'prod', ratio:0, amount:0 });
            }
            this.calcDistributeAll();
        },
        delDistributeRow(type, idx) {
            if(type === 'hostDept' && this.distributeHostDeptList.length > 1){
                this.distributeHostDeptList.splice(idx,1);
            }else if(type === 'designLeader' && this.distributeDesignLeaderList.length > 1){
                this.distributeDesignLeaderList.splice(idx,1);
            }
            this.calcDistributeAll();
        },
        // 切换折叠▲/展开▼
        toggleCollapse(key) {
            const idx = this.activeCollapseKeys.indexOf(key);
            if (idx > -1) {
                this.activeCollapseKeys.splice(idx, 1);
            } else {
                this.activeCollapseKeys.push(key);
            }
        },
        // 增加专业弹框
        plus() {
            this.visible = true;
        },
        onSelectChange(keys) {
            this.selectedRowKeys = keys;
        },
        cancel() {
            this.visible = false;
        },
        ok() {
            if (this.selectedRowKeys.length === 0) {
                this.$message.error('请选择专业类型！');
                return;
            }
            this.selectedRowKeys.forEach(key => {
                const item = this.majorTypes.find(t => t.key === key);
                if (item && !this.distributeRestDeptList.find(d => d.name === item.name)) {
                    // 创建带有固定角色分配的专业
                    this.distributeRestDeptList.push({
                        name: item.name,
                        ratio: 0,
                        amount: 0,
                        roleList: this.createDefaultRoleList()
                    });
                }
            });
            this.visible = false;
            this.selectedRowKeys = [];
            this.calcDistributeAll();
        },
        // 创建默认角色列表
        createDefaultRoleList() {
            return this.defaultRoleConfig.map(role => ({
                name: role.name,
                fixedRatio: role.ratio,
                amount: 0,
                personList: [{ userName: '', userId: '', orgName: '', instituteType: 'branch', ratio: 0, amount: 0 }]
            }));
        },
        // 重新计算角色比例（删除角色后）
        recalculateRoleRatios(dept) {
            const roleList = dept.roleList;
            const totalRatio = roleList.reduce((sum, role) => sum + role.fixedRatio, 0);
            // 按比例重新分配
            roleList.forEach(role => {
                role.fixedRatio = this.roundTo2Decimals((role.fixedRatio / totalRatio) * 100);
            });
        },
        // 删除角色
        delRole(dIdx, rIdx) {
            const dept = this.distributeRestDeptList[dIdx];
            const role = dept.roleList[rIdx];

            if (role.name === '审定') {
                // 删除审定后使用写死的比例配置
                dept.roleList.splice(rIdx, 1);
                // 更新剩余角色的比例
                dept.roleList.forEach(r => {
                    const config = this.roleConfigWithoutFinalReview.find(c => c.name === r.name);
                    if (config) {
                        r.fixedRatio = config.ratio;
                    }
                });
            } else {
                // 其他角色删除后按比例重新计算
                if (dept.roleList.length > 1) {
                    dept.roleList.splice(rIdx, 1);
                    this.recalculateRoleRatios(dept);
                }
            }
            this.calcDistributeAll();
        },
        // 增加审定角色
        addFinalReviewRole(dIdx) {
            const dept = this.distributeRestDeptList[dIdx];
            // 添加审定角色
            dept.roleList.push({
                name: '审定',
                fixedRatio: 15,
                amount: 0,
                personList: [{ userName: '', userId: '', orgName: '', instituteType: 'branch', ratio: 0, amount: 0 }]
            });
            // 恢复默认比例配置
            dept.roleList.forEach(r => {
                const config = this.defaultRoleConfig.find(c => c.name === r.name);
                if (config) {
                    r.fixedRatio = config.ratio;
                }
            });
            this.calcDistributeAll();
        },
        // 剩余占比-人员选择
        onSelectRestPerson(arr, dIdx, rIdx, pIdx) {
            if (arr.length === 0) return;
            const obj = arr[0];
            const person = this.distributeRestDeptList[dIdx].roleList[rIdx].personList[pIdx];
            if (person) {
                const org = this.organizationList.find(o => o.uniqueName === obj.deptUniqueName);
                person.userName = obj.name;
                person.userId = obj.userId;
                person.orgName = obj.deptUniqueName;
                person.instituteType = org ? (org.instituteType || obj.instituteType || 'branch') : (obj.instituteType || 'branch');
                this.calcDistributeAll();
            }
        },
        // 剩余占比-增加人员
        addRestPerson(dIdx, rIdx) {
            this.distributeRestDeptList[dIdx].roleList[rIdx].personList.push({ userName: '', userId: '', orgName: '', instituteType: 'branch', ratio: 0, amount: 0 });
            this.calcDistributeAll();
        },
        // 剩余占比-删除人员
        delRestPerson(dIdx, rIdx, pIdx) {
            const personList = this.distributeRestDeptList[dIdx].roleList[rIdx].personList;
            if (personList.length > 1) {
                personList.splice(pIdx, 1);
                this.calcDistributeAll();
            }
        },
        // 剩余占比-专业增删
        delRestDept(dIdx) {
            if (this.distributeRestDeptList.length > 0) {
                this.distributeRestDeptList.splice(dIdx, 1);
                this.calcDistributeAll();
            }
        },
    }
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding:24px 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
}
</style>

<style lang="less">
.distribute-div{
    width: 80%;
    margin: auto;
}
.distribute-wrapper {
    background: #f5f5f5;
    padding: 16px;
    margin-top: 8px;

    .distribute-title {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 16px;
        margin-bottom: 8px;

        &:first-child {
            margin-top: 0;
        }
    }

    .distribute-block {
        background: #fff;
        padding: 12px;
        //margin-bottom: 12px;
        //width: 90%;
        margin: auto;
    }

    .distribute-row {
        display: flex;
        gap: 8px;
        align-items: center;
        margin-bottom: 6px;
        &.header-row {
            font-weight: 500;
            margin-bottom: 8px;
        }
        .num-col,
        .num-input {
            width: 100px;
            flex-shrink: 0;
        }
        .opt-col {
            width: 120px;
            flex-shrink: 0;
        }
    }
    .distribute-row > .phase-tag {
        flex: none;
    }
    .phase-tag {
        width: 120px;
        height: 32px;
        font-size: 13px;
        background: #1890ff;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        flex: none;
    }

    // override ant-collapse in distribute area to match phase.vue style
    .ant-collapse {
        border: none;
        background: transparent;

        > .ant-collapse-item {
            border-bottom: none;
            margin-bottom: 12px;

            > .ant-collapse-header {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
                background: #fff;
                border-radius: 2px;
                padding: 10px 12px 10px 32px;
            }

            .ant-collapse-content {
                border: none;
                > .ant-collapse-content-box {
                    padding: 0;
                }
            }
        }
    }
}
// 修复回款记录表格单选框样式
.subpackage-payment-branch-institute {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
        .ant-radio-wrapper {
            .ant-radio {
                .ant-radio-inner {
                    border-color: #d9d9d9;

                    &:after {
                        background-color: #1890ff;
                    }
                }
            }

            &:hover .ant-radio {
                .ant-radio-inner {
                    border-color: #40a9ff;
                }
            }
        }
    }
}

.approvalFeesTitle{
    font-size: 14px;
    margin: 10px 0;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
